import React from 'react';
import SEOHead from '../../components/seo/SEOHead';
import { motion } from 'framer-motion';

const CookiePolicy = () => {
  return (
    <>
      <SEOHead
        title="Cookie Policy"
        description="Learn about how we use cookies and similar technologies on Animatronic Database."
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-3xl font-bold text-content-primary mb-8">Cookie Policy</h1>
          
          <div className="prose prose-invert max-w-none space-y-6">
            <p className="text-content-secondary">Effective Date: 01/13/2025</p>
This Cookie Policy explains how Animatronic Database uses cookies and similar technologies.
            <section>
              <h2>1. What Are Cookies</h2>
              <p>
                Cookies are small text files stored on your device when you visit our website.
                They help us provide essential functionality and improve your experience.
              </p>
            </section>

            <section>
              <h2>2. Types of Cookies We Use</h2>
              <h3>Essential Cookies</h3>
              <ul>
                <li>Analytics Cookies: We use Netlify metrics to track site traffic and unique visitors.</li>
                <li>We may use cookies for ads or personalization.</li>
              </ul>
            </section>

            <section>
              <h2>3. Cookie Management</h2>
              <p>You can disable cookies in your browser settings. Note that some features may not function properly without cookies.</p>
            </section>

            <section>
              <h2>4. Updates to Policy</h2>
              <p>
                We may update this Cookie Policy periodically. Check this page for the latest
                information about our cookie practices.
              </p>
            </section>

            <section>
              <h2>5. Contact Us</h2>
              <p>
                Questions about our cookie policy? Contact us at{' '}
                <a href="mailto:legal@animatronicdatabase.com" className="text-brand hover:text-brand-light">
                  legal@animatronicdatabase.com
                </a>
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default CookiePolicy;